import memoizeOne from 'memoize-one';

import { FeatureFlagClient } from '@trello/feature-flag-client';

// eslint-disable-next-line no-restricted-imports
import token from 'common/lib/util/token';

export const featureFlagClient = new FeatureFlagClient({
  key: token.getMyId() || 'notLoggedIn',
  anonymous: !token.getMyId(),
});

/**
 * Because we have to check this flag so early on, and we block initial render
 * of the app while waiting for the LaunchDarkly client to be initialized, we
 * need to memoize this value. If the LaunchDarkly localStorage cache is empty,
 * we go to the network for data but timeout after 10 seconds. If we timed out
 * but the request eventually completes, it's better to have consistency
 * between reads (even if we're receiving the default value).
 *
 * We should remove this when the feature is fully released.
 */
export const isGammaHeaderEnabled = memoizeOne(() => {
  return featureFlagClient.get('gamma.header', false);
});
export const isGammaNotificationsEnabled = memoizeOne(() => {
  return featureFlagClient.get('gamma.notifications', false);
});



// WEBPACK FOOTER //
// ./app/common/lib/feature-flag-client.ts